import instanceQuery from 'graphql/queries/supplier/SupplierGlobalAmendQuery.graphql';
import defaultQuery from 'graphql/queries/supplier/SupplierGlobalAmendDefault.graphql';
import mutationQuery from 'graphql/mutations/supplier/SupplierGlobalAmendMutation.graphql';
import fragment from 'graphql/fragments/supplier/SupplierGlobalAmendFragment.graphql';

const SupplierGlobalAmend = {
  type: 'SupplierGlobalAmend',
  title: 'Supplier Global Amendments',
  formTitle: 'Supplier Global Amendments',
  formUrl: '/Suppliers/GlobalAmendments/',
  default: defaultQuery,
  instance: instanceQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'SUPPLIERS_GLOBAL_AMENDMENTS',
  resultUrl: '/Suppliers/SupplierGlobalAmendResultDetails/Workspace/',
};

export default SupplierGlobalAmend;
